var scope_0 = require('/home/runner/_work/cc-everywhere/cc-everywhere/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/147d30d8dc7116ab4c0b5e7243730d12.js').default;
var scope_1 = require('/home/runner/_work/cc-everywhere/cc-everywhere/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9a679c90c46459d355ab8d09c7c3f570.js').default;
var scope_2 = require('/home/runner/_work/cc-everywhere/cc-everywhere/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c23713e9a51dde95cfab0e6e46111987.js').default;
var scope_3 = require('/home/runner/_work/cc-everywhere/cc-everywhere/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    